<div class="game-clock-dialog">
  <div class="title" [ghs-label]="'duration.gameClock'"></div>

  <div class="control" (click)="toggleGameClock()">
    <img class="ghs-svg" [src]="'./assets/images/' + (current ? 'clock-out' : 'clock-in') + '.svg'" />
    <span [ghs-label]="'duration.gameClock.' + (current ? 'clockOut' : 'clockIn')"></span>
  </div>

  <div class="timestamps">
    @if (current) {
      <div class="timestamp current" [ngClass]="{ 'has-more': gameClock.length > 1 }">
        <span [ghs-label]="'duration.gameClock.current'" [ghs-label-args]="[current | ghsDurationLabel]"></span>
      </div>
    }
    @if (gameManager.game.gameClock.length > 1) {
      <div class="timestamp current" [ngClass]="{ 'has-more': gameClock.length > 1 }">
        <span [ghs-label]="'duration.gameClock.total'" [ghs-label-args]="[total | ghsDurationLabel]"></span>
      </div>
    }
    @for (timestamp of gameClock | trackUUID; track timestamp._trackUUID; let i = $index) {
      <div class="timestamp" ghs-pointer-input (doubleClick)="merge(i)">
        @if (timestamp.clockOut) {
          <span
            [ghs-label]="'duration.gameClock.timestamp'"
            [ghs-label-args]="[
              (timestamp.clockIn | date: 'short' : timeZone : settingsManager.settings.locale) || '',
              (timestamp.clockOut - timestamp.clockIn) / 1000 | ghsDurationLabel
            ]"
          >
          </span>
        }
      </div>
    }
    @if (gameClock.length < gameManager.game.gameClock.length) {
      <span class="more" [ghs-label]="'duration.gameClock.more'" (click)="more()"></span>
    }
  </div>
</div>
